module.exports = __webpack_public_path__ + "static/media/logo-text.1c4c01e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-text.svg
// module id = 210
// module chunks = 0